import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

const Sofa = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <g>
        <path
          fill={props.color || theme.palette.grey600}
          fillRule="evenodd"
          d={
            props.variant === "line"
              ? "M15.333 6a3.334 3.334 0 013.33 3.189l.004.144v2.114a2.001 2.001 0 011.327 1.725l.006.161v4a.667.667 0 01-.568.66l-.099.007H4.667a.667.667 0 01-.66-.568L4 17.333v-4a2 2 0 011.333-1.886V9.333a3.334 3.334 0 013.19-3.33L8.666 6h6.666zM18 12.667a.666.666 0 00-.66.568l-.007.098v1.334a.667.667 0 01-.568.66l-.098.006H7.333a.667.667 0 01-.66-.568l-.006-.098v-1.334a.666.666 0 00-1.326-.098l-.008.098v3.334h13.334v-3.334a.667.667 0 00-.492-.643l-.097-.019-.078-.004zM8.667 7.333h6.666l.118.004a2 2 0 011.882 1.996v2.114A2 2 0 0016 13.333V14H8v-.667l-.006-.161a2 2 0 00-1.327-1.725V9.333l.003-.117a2 2 0 011.997-1.883z"
              : "M8 14v-.667a2.67 2.67 0 00-2.667-2.666V10a4 4 0 014-4h5.334a4 4 0 014 4v.667A2.67 2.67 0 0016 13.333V14H8zm9.333-.667a1.334 1.334 0 012.667 0V18H4v-4.667a1.334 1.334 0 012.667 0v2h10.666v-2z"
          }
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

export { Sofa };
